import moment from "moment";
import { Link } from "react-router-dom";
import styles from "./Copyright.module.css";

export default function Copyright() {
  return (
    <div className={styles.copyRow}>
      <p>Copyright &copy; {moment().format("YYYY")} all Rights Reserved.</p>
      <div className={styles.links}>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
      </div>
    </div>
  );
}
